import { getMediaImageStyle } from "shared/util/style";
import { useItem } from "../util/db.js";

export function RawBackgroundIcon({ image, name, hue, mods = "" }: { image?: string | null | undefined; hue?: number | undefined; name?: string | undefined; mods?: string | undefined }): React.ReactElement {
	return <figure style={getMediaImageStyle(image, hue)} title={name} className={`background ${mods}`} />;
}

/** Load a single background images by its ID. */
export function BackgroundIcon({ id, mods }: { id: string; mods?: string | undefined }): React.ReactElement | null {
	const item = useItem("reward", id);
	return <RawBackgroundIcon {...item.value} mods={mods} />;
}
